export const ALL_BLOG_POSTS = `
query AllBlogPosts {
    blogPosts (pagination: { limit: 100 } sort: "Datum:desc") {
        documentId
        title
        slug
        publishedAt
        Datum
        previewImage {
            url
            alternativeText
        }
    }
}
`;
